import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export const CHECKOUT_URL = 'https://sciences-pretes.impultienda.ar/checkout';
type CtaButtonProps = {
  label?: string;
  href?: string;
  className?: string;
};
export function CtaButton({
  label = 'Obtenir le pack SCIENCES PRÊTES™',
  href = CHECKOUT_URL,
  className = ''
}: CtaButtonProps) {
  const isInternal = href.startsWith('#');
  return <a href={href} target={isInternal ? undefined : '_blank'} rel={isInternal ? undefined : 'noopener noreferrer'} className={`group inline-flex items-center justify-center gap-2.5 whitespace-nowrap rounded-full bg-pen px-5 py-4 text-center text-[13px] font-semibold text-white shadow-[inset_0_1px_0_rgba(255,255,255,0.2),0_14px_28px_-14px_rgba(200,49,43,0.75)] transition-[transform,background-color] duration-150 ease-out hover:bg-pen-dark active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-pen/30 sm:px-9 sm:py-[1.15rem] sm:text-base ${className}`} data-id="element-44" data-mp="qk1zz2w5dedf">
      <span data-id="element-45" data-mp="35xxp4gty87oj">{label}</span>
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-46" data-mp="35yqsd7tp8f1x" />
    </a>;
}